// 商品レビュー一覧 category (/pages/category-reviews?category={handle}&product={handle}).
// markup design (2 cột sidebar + list), numbered pagination.
// Chờ ink:api:ready → GET /category-reviews (summary 6 trục + sort + cards paginate).
// Public (guest xem được). Star ★ inline. Fail-open.
(function () {
  'use strict';

  const PER_PAGE = 10;
  const ICONS = window.INK_REVIEW_ICONS || {};
  // 6 trục product (short label + câu hỏi) — 1:1 review-eval-fieldset kind=product.
  const AXES = ['印刷結果', '定着性', '耐光性', '価格', '印刷コスト', '使いやすさ'];
  const QUESTIONS = [
    'インクorトナーの発色は良いか？',
    '用紙に馴染んで、色ムラやにじみはないか？',
    '印刷品質は長持ちし、色褪せしていないか？',
    '商品の価格は適正か？',
    'コストパフォーマンスは高いか？',
    'プリンターへのセットは簡単に行えるか？',
  ];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // ★ cam design (#ff8a1c) có NỬA SAO — band + markup dùng chung
  // `assets/review-stars.js` (bản song sinh snippet `review-star-band` /
  // getSummaryStar ps_reviewCnet.php:219-245).
  function starsHtml(value) {
    return window.inkReviewStars ? window.inkReviewStars.html(value) : '';
  }

  function fmtDate(ts) {
    const d = new Date(Number(ts) * 1000);
    if (isNaN(d.getTime())) return '';
    return `${d.getMonth() + 1}月${d.getDate()}日`;
  }

  // Card design: rating+title trái, khách (icon+属性) phải; body; 購入商品; 店舗返信.
  function cardHtml(r) {
    const icon = ICONS[String(r.p_icon)] || ICONS['0'] || '';
    const printerLine = r.printer_pn ? `<br>【プリンター型番】${esc(r.printer_pn)}` : '';
    const meta = `${esc(r.pref_name) || '—'}のお客様<br>【投稿日】${fmtDate(r.cdate)}　${esc(r.order_count)}${printerLine}`;
    const img = r.review_image ? `<div class="mt-3"><img src="${esc(r.review_image)}" loading="lazy" class="max-w-[200px] max-h-[200px] rounded border" alt="レビュー画像"></div>` : '';
    const prod = r.product_name
      ? `<div class="mt-3 grid gap-2 rounded bg-slate-50 p-3 text-sm leading-6 lg:grid-cols-[110px_minmax(0,1fr)]"><span class="font-bold text-gray-800">購入商品</span>${r.product_url ? `<a class="ik-anywhere text-ink-blue" href="${esc(r.product_url)}">${esc(r.product_name)}</a>` : `<span class="ik-anywhere">${esc(r.product_name)}</span>`}</div>`
      : '';
    const reply = r.shop_comment
      ? `<div class="mt-3 rounded border border-ink-green bg-ink-paleGreen p-3 text-sm leading-7"><p class="font-bold text-ink-greenDark">インク革命.COM 担当者より</p><p class="mt-1 text-gray-800">${esc(r.shop_comment).replace(/\n/g, '<br>')}</p></div>`
      : '';
    return `
      <li class="rounded border border-ink-grayLine bg-white p-5 shadow-soft">
        <div class="flex flex-col gap-2 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <div class="flex flex-wrap items-center gap-2">
              <span class="text-lg font-bold text-ink-orange">${starsHtml(r.summary)}</span>
              <span class="text-lg font-bold text-ink-red">${Number(r.summary).toFixed(1)}</span>
            </div>
            <h3 class="mt-2 text-lg font-bold">${esc(r.review_title)}</h3>
          </div>
          <div class="flex shrink-0 items-center gap-2">
            <img class="h-12 w-12 shrink-0 object-contain" src="${esc(icon)}" width="48" height="48" alt="お客様アイコン">
            <p class="text-xs font-bold leading-5 text-gray-700">${meta}</p>
          </div>
        </div>
        <p class="mt-3 whitespace-pre-line leading-7">${esc(r.review_body)}</p>
        ${img}
        ${prod}
        ${reply}
      </li>`;
  }

  function boot() {
    const root = document.querySelector('[data-category-reviews]');
    if (!root) return;
    const params = new URLSearchParams(location.search);
    const category = params.get('category') || '';
    const productHandle = params.get('product') || '';
    const pid = params.get('pid') || '';
    const itemsEl = root.querySelector('[data-review-items]');
    const pager = root.querySelector('[data-pager]');
    const sortSel = root.querySelector('[data-sort]');
    const resultInfo = root.querySelector('[data-result-info]');
    let page = 1;
    let lastPage = 1;

    // CTA レビューを書く → product-review-form (mang theo product + pid nếu có).
    const writeLink = root.querySelector('[data-write-link]');
    if (writeLink && productHandle) {
      writeLink.href = `/pages/product-review-form?product=${encodeURIComponent(productHandle)}${pid ? '&pid=' + encodeURIComponent(pid) : ''}`;
    }

    // Tên series (category_name) + link collection → h1 subtitle + breadcrumb.
    function renderSeries(s) {
      if (!s || !s.category_name) return;
      const href = s.category_handle ? `/collections/${s.category_handle}` : (productHandle ? `/collections/${category}` : '#');
      root.querySelectorAll('[data-series-link]').forEach((a) => { a.textContent = s.category_name; a.href = href; });
      root.querySelector('[data-series-title]')?.classList.remove('hidden');
      root.querySelector('[data-breadcrumb-series]')?.classList.remove('hidden');
    }

    function renderSummary(s) {
      root.querySelector('[data-summary-skeleton]')?.remove();
      renderSeries(s);
      const c = root.querySelector('[data-summary-content]');
      if (!s || !c) return;
      c.classList.remove('hidden');
      root.querySelector('[data-summary-avg]').textContent = Number(s.avg_rating).toFixed(1);
      root.querySelector('[data-summary-stars]').innerHTML = starsHtml(s.avg_rating);
      root.querySelector('[data-summary-count]').textContent = s.count || 0;
      const bd = s.breakdown || {};
      root.querySelector('[data-summary-breakdown]').innerHTML = AXES.map((label, i) => {
        const v = Number(bd['eval_' + (i + 1)]) || 0;
        const pct = Math.round((v / 5) * 100);
        return `<li>
          <div class="flex items-center justify-between"><span class="font-bold">${label}</span><span class="font-bold text-ink-red">${v.toFixed(1)}</span></div>
          <p class="mt-0.5 text-xs leading-5 text-gray-600">${QUESTIONS[i]}</p>
          <span class="relative mt-1 block h-2 overflow-hidden rounded-full bg-gray-200"><span class="absolute inset-y-0 left-0 rounded-full" style="width:${pct}%;background:#ff8a1c"></span></span>
        </li>`;
      }).join('');
    }

    // Numbered pagination theo design (1 2 3 … 次へ » 最後 »»).
    function renderPager() {
      if (lastPage <= 1) { pager.classList.add('hidden'); pager.innerHTML = ''; return; }
      pager.classList.remove('hidden');
      const cell = (p, label, active) => active
        ? `<span class="inline-flex min-h-9 min-w-9 items-center justify-center rounded bg-ink-orange px-3 text-white">${label}</span>`
        : `<a href="#" data-page="${p}" class="inline-flex min-h-9 min-w-9 items-center justify-center rounded border border-ink-grayLine bg-white px-3">${label}</a>`;
      const win = [];
      for (let p = 1; p <= lastPage; p++) {
        if (p === 1 || p === lastPage || (p >= page - 2 && p <= page + 2)) win.push(p);
      }
      const parts = [];
      let prev = 0;
      win.forEach((p) => {
        if (p - prev > 1) parts.push('<span class="px-1 text-gray-500">…</span>');
        parts.push(cell(p, String(p), p === page));
        prev = p;
      });
      if (page < lastPage) {
        parts.push(`<a href="#" data-page="${page + 1}" class="inline-flex min-h-9 items-center justify-center rounded border border-ink-grayLine bg-white px-3">次へ »</a>`);
        parts.push(`<a href="#" data-page="${lastPage}" class="inline-flex min-h-9 items-center justify-center rounded border border-ink-grayLine bg-white px-3">最後 »»</a>`);
      }
      pager.innerHTML = parts.join('');
    }

    async function load() {
      let j;
      try { j = await window.inkApi.get('/category-reviews', { category, page, per_page: PER_PAGE, sort: sortSel ? sortSel.value : 0 }); }
      catch (e) {
        console.warn('category-reviews load fail', e);
        itemsEl.innerHTML = '<li class="text-center text-gray-500 py-6">読み込みに失敗しました。</li>';
        root.querySelector('[data-summary-skeleton]')?.remove();
        return;
      }

      renderSummary(j && j.summary);
      const data = (j && j.data) || {};
      const items = data.data || [];
      lastPage = data.last_page || 1;
      const total = data.total || 0;
      if (resultInfo) {
        if (total > 0) {
          const from = (page - 1) * PER_PAGE + 1;
          const to = Math.min(page * PER_PAGE, total);
          resultInfo.innerHTML = `${total}件中 <span class="text-ink-red">${from}〜${to}件目</span> を表示`;
        } else {
          resultInfo.textContent = '';
        }
      }

      if (!items.length) {
        itemsEl.innerHTML = '<li class="text-center text-gray-500 py-6">まだレビューがありません。</li>';
        pager.classList.add('hidden');
        return;
      }
      itemsEl.innerHTML = items.map(cardHtml).join('');
      renderPager();
      window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
    }

    sortSel?.addEventListener('change', () => { page = 1; load(); });
    pager?.addEventListener('click', (e) => {
      const a = e.target.closest('[data-page]');
      if (!a) return;
      e.preventDefault();
      const p = parseInt(a.dataset.page, 10);
      if (p && p !== page) { page = p; load(); }
    });

    load();
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) startOnce();
  else { document.addEventListener('ink:api:ready', startOnce, { once: true }); window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000)); }
})();
